<template>
  <div class>
    <toptitle :title="topTitle" :subtitle="topSubTitle" :isSearch="true">
      <div class="search-input-container container">
        <div class="search-form col-md-6 offset-md-3" @keyup.enter="search">
          <input class="search-model" v-model="model" type="text" @keyup.enter="search" name="model" 
          :placeholder="currentLanguage == 'CN' ? '请输入产品名称' : currentLanguage == 'EN' ? 'Please enter the product name' : '製品名を入力してください'" />
          <input class="search-btn" type="button" @click="search()" 
          :value="currentLanguage == 'CN' ? '搜索' : currentLanguage == 'EN' ? 'Search' : '検索'" />
        </div>
      </div>
    </toptitle>
    <div class="search-container">
      <div class="container not-rounded">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="products-title">
              <span v-if="currentLanguage == 'CN'">搜索产品</span>
              <span v-else-if="currentLanguage == 'EN'">Search product</span>
              <span v-else-if="currentLanguage == 'JP'">製品検索</span>
            </div>
            <div class="row">
              <div
                class="col-6 col-md-3 products-items"
                v-for="(data, index) in productsData"
                :key="index"
                >
                <router-link tag="a" :to="`/productscontent/${data._id}`" class="products-link" href="javascript:;">
                  <div class="products-img">
                    <img :src="data.image[0].url" :alt="data.name" />
                  </div>
                  <div class="products-text">
                    <p class="products-text-name">{{ data.name }}</p>
                    <p class="products-text-model">{{ data.number }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import productslistCN from '../data/CN/productslist_CN.json'
import productslistEN from '../data/EN/productslist_EN.json'
import productslistJP from '../data/JP/productslist_JP.json'
export default {
  data() {
    return {
      topTitle: '站内搜索',
      topSubTitle: '专业光学自动化设备，实力见证品牌',
      productsData: [],
      model: '',
      searchResult: true,
      currentLanguage: '' // 当前语言
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
            _this.currentLanguage = e.newValue
          }
      })
  },
  methods: {
    fetch(list) {
        for (var i = 0; i<list.length; i++) {
            for (var j = 0; j<list[i].productsList.length; j++) {
                if (list[i].productsList[j].alias.indexOf(this.model) !== -1) {
                    this.productsData.push(list[i].productsList[j])
                }
            }
        }
    },
    search: function() {
        this.productsData = []
        if (!this.model) return
      if (this.currentLanguage == "CN") {
          this.fetch(productslistCN)
      } else if (this.currentLanguage == "EN") {
          this.fetch(productslistEN)
      } else if (this.currentLanguage == "JP") {
          this.fetch(productslistJP)
      }
      // const req = await this.$http.get(`findproducts/${this.model}`)
      // this.productsData = req.data
    }
  },
  created() {
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
  }
}
</script>
<style scoped>
  .search-btn {
    cursor: pointer;
  }
@media (max-width: 768px) {
  .search-model {
    width: 100%;
  }
}
.search-container {
  padding: 30px 0;
}

.search-input-container {
  margin-top: 16px;
  height: 44px;
}
.search-form,
.search-btn,
.search-model {
  display: inline-block;
  height: 100%;
  outline: none;
  border-radius: 0;
}
.search-form {
  padding: 0;
  display: flex;
}

.search-model {
  text-indent: 10px;
  font-size: 14px;
  color: #666666;
  flex: 4;
  border: 1px solid #fff;
}
.search-btn {
  background-color: #048bd4;
  color: #fff;
  flex: 1;
  border: 1px solid #fff;
}

.products-box {
  margin-bottom: 26px;
}
.products-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.products-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}

@media (max-width: 768px) {
  .products-items {
    margin-top: 20px;
  }
}

.products-items {
  margin-top: 30px;
}

.products-link {
  display: block;
  border: 1px solid #e8e8e8;
  transition: border 0.3s ease;
  transition: box-shadow 0.3s ease;
}

.products-link:hover {
  border-color: #048bd4;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.products-link:hover .products-text-model {
  color: #fff;
}

.products-link:hover .products-text {
  background-color: #048bd4;
}
.products-link:hover .products-img img {
  transform: scale(1.1);
}

.products-img {
  overflow: hidden;
  text-align: center;
  /* padding: 20px 30px; */
}
.products-img img {
  width: 100%;
  transition: all 0.3s ease;
}
.products-text {
  text-align: center;
  padding: 10px;
  background-color: #e8e8e8;
  transition: background 0.3s ease;
}

.products-text-name {
  font-size: 14px;
  line-height: 24px;
}
.products-text-model {
  font-size: 12px;
  color: #666;
}
.search-false {
  padding: 100px 0;
  text-align: center;
  color: #666;
}
</style>